export default class InvalidTransactionTypeException extends Error {
	
}